export default "__VITE_ASSET__b34544d7__"